import React from "react";
import { Instagram, Linkedin, ArrowUpRight } from "lucide-react";

const SOCIALS = [
  {
    label: "Instagram",
    handle: "@deryaelizyildiz",
    url: "https://www.instagram.com/deryaelizyildiz/",
    icon: Instagram,
    color: "from-pink-500/20 to-purple-500/10",
  },
  {
    label: "X (Twitter)",
    handle: "@deryaelizyildiz",
    url: "https://x.com/deryaelizyildiz",
    icon: null,
    iconClass: "fa-brands fa-x-twitter",
    color: "from-white/15 to-white/5",
  },
  {
    label: "LinkedIn",
    handle: "Derya Eliz Yıldız",
    url: "https://www.linkedin.com/in/derya-eliz-y%C4%B1ld%C4%B1z-ba70263b5/",
    icon: Linkedin,
    color: "from-blue-500/20 to-blue-700/10",
  },
];

export default function Contact({ telegramUrl }) {
  return (
    <section
      id="iletisim"
      className="relative py-24 md:py-32 bg-[#070e26] border-t border-white/5"
      data-testid="contact-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-5">
            <span
              className="section-eyebrow"
              data-testid="contact-eyebrow"
            >
              İletişim
            </span>
            <h2
              className="font-serif text-white text-[clamp(2rem,4.6vw,3.75rem)] leading-[1.08] mt-3"
              data-testid="contact-title"
            >
              Yakın takip için,
              <br />
              <span className="italic text-gold-gradient">birlikte olalım.</span>
            </h2>
            <p className="mt-6 text-[#cbd5e1] text-base md:text-lg font-light leading-relaxed max-w-md">
              Güncel paylaşımlar ve canlı piyasa yorumları için sosyal medya
              hesaplarımı takip edebilir, anlık bildirimler için Telegram VIP
              grubuna katılabilirsiniz.
            </p>

            <a
              href={telegramUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-gold mt-9 px-7 py-4 rounded-full inline-flex items-center gap-2.5 text-[15px]"
              data-testid="contact-telegram-cta"
            >
              <i className="fa-brands fa-telegram text-lg" />
              Telegram VIP Grubuna Katıl
              <ArrowUpRight size={18} />
            </a>
          </div>

          <div className="lg:col-span-7">
            <div
              className="grid sm:grid-cols-2 gap-4"
              data-testid="social-grid"
            >
              {SOCIALS.map((s, i) => {
                const Icon = s.icon;
                return (
                  <a
                    key={s.label}
                    href={s.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="glass-card rounded-2xl p-7 group relative overflow-hidden"
                    data-testid={`social-card-${s.label.toLowerCase().replace(/[^a-z]/gi, "")}`}
                  >
                    <div
                      className={`absolute inset-0 bg-gradient-to-br ${s.color} opacity-0 group-hover:opacity-100 transition-opacity duration-500`}
                    />
                    <div className="relative flex items-start justify-between">
                      <div>
                        <div className="w-11 h-11 rounded-full border border-white/15 flex items-center justify-center bg-white/5 group-hover:border-[#d4af37]/50 transition-colors duration-500">
                          {Icon ? (
                            <Icon size={18} className="text-white" />
                          ) : (
                            <i className={`${s.iconClass} text-white text-base`} />
                          )}
                        </div>
                        <div className="mt-5">
                          <div className="text-[10px] tracking-[0.28em] uppercase text-[#94a3b8]">
                            {s.label}
                          </div>
                          <div className="mt-1 font-serif text-white text-xl">
                            {s.handle}
                          </div>
                        </div>
                      </div>
                      <ArrowUpRight
                        size={20}
                        className="text-[#d4af37] opacity-60 group-hover:opacity-100 group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-500"
                      />
                    </div>
                  </a>
                );
              })}

              {/* Telegram card */}
              <a
                href={telegramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="sm:col-span-2 glass-card rounded-2xl p-7 group relative overflow-hidden border border-[#d4af37]/25"
                data-testid="social-card-telegram"
              >
                <div className="absolute inset-0 bg-gradient-to-br from-[#d4af37]/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <div className="relative flex items-center justify-between">
                  <div className="flex items-center gap-5">
                    <div className="w-12 h-12 rounded-full border border-[#d4af37]/50 flex items-center justify-center bg-[#d4af37]/10">
                      <i className="fa-brands fa-telegram text-[#d4af37] text-xl" />
                    </div>
                    <div>
                      <div className="text-[10px] tracking-[0.28em] uppercase text-[#d4af37]">
                        Telegram VIP
                      </div>
                      <div className="mt-1 font-serif text-white text-xl">
                        Özel Topluluk · Anlık Paylaşım
                      </div>
                    </div>
                  </div>
                  <ArrowUpRight
                    size={22}
                    className="text-[#d4af37] group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform duration-500"
                  />
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
